import gql from 'graphql-tag';

export const QUERY_COUNT_DASHBORD = gql`
  query countDashboardData($input: GetCountDashboardDataInput) {
    countDashboardData(input: $input) {
      orderData {
        currency
        orderCount
        stage
        totalPrice
      }
      currencyData {
        currency
        totalPrice
      }
      propertyData {
        propertyCount
        status
      }
    }
  }
`;
